module.exports = __webpack_public_path__ + "static/media/ic_bank_not_rejected.177768e9.svg";